<ion-content padding>
    <h2>{{ 'generic.PreviousEvaluations' | translate}}</h2>
    <h4>{{userName}}</h4>
    <ion-item>
        <ion-label>{{ 'generic.cycle' | translate}}</ion-label>
        <ion-select [(ngModel)]="selectedEvaluation" (ionChange)="changeEvaluation($event)">
            <ion-select-option
                *ngFor="let evaluation of previousEvaluations"
                [value]="evaluation"
                [disabled]="evaluation.errorMessage"
                (click)="alertErrorMessage(evaluation.errorMessage)"
            >
                {{ evaluation.cycleName }}</ion-select-option
            >
        </ion-select>
    </ion-item>
    <div class="question-group" *ngFor="let questionGroup of selectedEvaluation?.questionsGroups; let groupIndex = index">
        <h6>{{ !hideQuestionNumber ? (groupIndex + 1) + ' - ' + getText(questionGroup.globalizationConfig, 'title') : getText(questionGroup.globalizationConfig, 'title') }}</h6>
        <div class="question" *ngFor="let question of questionGroup.questions">
            <div *ngIf="question.typeConfig.type == QuestionTypeEnum.GroupedSlider">
                <ion-grid>
                    <ion-row class="header" style="width: 100%; background: var(--footer-background)">
                        <ion-col size="4">
                            <p>{{"generic.Category" | translate}}</p>
                        </ion-col>
                        <ion-col size="4">
                            <p>{{'generic.ManagerEvaluation' | translate}}</p>
                        </ion-col>
                        <ion-col size="4">
                            <p>{{'managerEvaluation.employeeAnswer' | translate}}</p>
                        </ion-col>
                    </ion-row>
                    <ion-row style="width: 100%" *ngFor="let globalizationConfig of question.groupedGlobalizationConfig; let index = index">
                        <ion-col size="4">
                            <p>{{ getText(globalizationConfig, 'title') }}</p>
                        </ion-col>
                        <ion-col size="4">
                            <p>{{ getQuestionAnswer(question, selectedEvaluation.evaluation, index) }}</p>
                        </ion-col>
                        <ion-col size="4">
                            <p>{{ getQuestionAnswer(question, selectedEvaluation.selfEvaluation, index) }}</p>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </div>
            <div *ngIf="question.typeConfig.type != QuestionTypeEnum.GroupedSlider && question.typeConfig.type != QuestionTypeEnum.Calculate">
                <h6>{{ getText(question.globalizationConfig, 'title') }}</h6>

                <div>
                    <p class="padding">{{ getQuestionAnswer(question, selectedEvaluation.evaluation) }}</p>

                    <div class="self-answer padding" *ngIf="getQuestionAnswer(question, selectedEvaluation.selfEvaluation) != '-'">
                        <p>{{'managerEvaluation.employeeAnswer' | translate}}:</p>
                        <p>{{ getQuestionAnswer(question, selectedEvaluation.selfEvaluation) }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="selectedEvaluation && selectedEvaluation.quadrantId && selectedEvaluation.nineBoxConfig">
        <h6>Resultado pós-calibragem</h6>
        <p>Posição atual: <b>quadrante {{hasInvertedQuadrants ? invertedQuadrants[selectedEvaluation.quadrantId - 1] : selectedEvaluation.quadrantId}}</b></p>
        <ion-grid
            *ngIf="selectedEvaluation.nineBoxConfig && selectedEvaluation.nineBoxConfig.xAxis && selectedEvaluation.nineBoxConfig.yAxis"
            style="display: flex; flex-direction: column-reverse"
        >
            <ion-row *ngFor="let row of selectedEvaluation.nineBoxConfig.xAxis.values; let rowIndex = index" class="row">
                <ion-col
                    *ngFor="let cell of selectedEvaluation.nineBoxConfig.yAxis.values; let columnIndex = index"
                    class="cell"
                    [ngClass]="{'selected': getQuadrantNumber(rowIndex, columnIndex) == selectedEvaluation.quadrantId}"
                    [ngStyle]="{'background': selectedEvaluation.nineBoxConfig.colors[getQuadrantNumber(rowIndex, columnIndex)]}"
                ></ion-col>
            </ion-row>
        </ion-grid>
    </div>
</ion-content>

<ion-footer mode="ios">
    <ion-toolbar mode="ios">
        <ion-row>
            <ion-col size="12" style="display: flex; justify-content: center">
                <ion-button fill="outline" mode="ios" (click)="dismiss()"> {{ 'generic.close' | translate }} </ion-button>
            </ion-col>
        </ion-row>
    </ion-toolbar>
</ion-footer>
